// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { MarketoConfig } from '../../constants/marketo-constants';
import scriptLoadingHelper from '../script-loading-helper';

/** Async load Munchkin script IF PWS and OneTrust have finished loading */
const munchkinHelper = {
  permissions: {} as InitializationProperties,

  initialize: (permissions: InitializationProperties): Promise<void> => {
    munchkinHelper.permissions = permissions;
    munchkinHelper.load();
  },

  load: () => {
    if (document.getElementById('munchkin-script-tag')) {
      return;
    }

    if (munchkinHelper.permissions.analyticsTrackingEnabled) {
      scriptLoadingHelper.injectClientScript('munchkin-script-tag', MarketoConfig.SRC_URL, 'afterInteractive', {
        async: true,
        onLoad: munchkinHelper.onLoad,
      });
    }
  },

  onLoad: () => {
    window.Munchkin?.init(MarketoConfig.MUNCHKIN_ID, {
      asyncOnly: true,
      cookieAnon: true,
      wsInfo: MarketoConfig.PARTITION,
    });
  },
};

export default munchkinHelper;
